export const MessageModalTypes = {
  OPEN_MESSAGE_MODAL: 'OPEN_MESSAGE_MODAL',
};
